import { Injectable } from '@angular/core';
import { AppConfig } from '@solar/app.config';
import { Observable, of } from 'rxjs';

//import { AppSettings } from "./appsettings";
export class LibToConfigureConfiguration {
  name: string;
}
@Injectable({ providedIn: 'root' })
export abstract class ConfigurationProvider {
  abstract get config(): LibToConfigureConfiguration;
}
@Injectable({ providedIn: 'root' })
export class AppSettingsService {
  get config(): any {
    let cfg={
      app_version:AppConfig.app_version
      ,API_DATE_FORMAT:AppConfig.API_DATE_FORMAT
      ,gis_configuration: AppConfig.gis_configuration

    };
    console.log("AppSettingsService is returning settings",cfg);
    return cfg;
  }
  

/*   getSettings(): Observable<AppSettings> {
    let settings = new AppSettings();
    return of<AppSettings>(settings);
  } */
}